import Slider from 'react-slick';

import carouselSettings from './carousel-settings';

function UpcomingEvents({ children }) {
  if (!children || children.length === 0) {
    return null;
  }
  if (children.length > 1) {
    return (
      <div className="upcoming-events">
        <Slider {...carouselSettings}>{children}</Slider>
      </div>
    );
  }

  return (
    <div className="upcoming-events au-flex au-justify-center">{children}</div>
  );
}

export default UpcomingEvents;
